









import { Component, Vue } from "vue-property-decorator";
import { Observer } from "mobx-vue";
import { reaction } from "mobx";
import mapStore from "@/store/mapStore";
import { latLng } from "leaflet";
const L = window["L"];
import { findRealParent } from "vue2-leaflet";
import CollectionEventSummary from "@/components/CollectionEvents/CollectionEventSummary.vue";

@Observer
@Component({ components: { CollectionEventSummary } })
export default class CollectionEventPopup extends Vue {
  mapStore = mapStore;
  popup: L.Popup | null = null;
  dispose?: () => void;

  mounted() {
    this.dispose = reaction(
      () => ({ isOpen: mapStore.isCollectionEventPopupOpen, collectionEvent: mapStore.selectedCollectionEvent }),
      ({ isOpen, collectionEvent }) => {
        const parent = findRealParent(this);
        if (collectionEvent && isOpen) {
          this.popup = L.popup({
            closeButton: false,
            className: "collection-event-popup v-application",
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            autoPanPaddingTopLeft: (this as any).$mq === "sm" ? [5, 66] : [5, 80],
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            autoPanPaddingBottomRight: (this as any).$mq === "sm" ? [5, 5] : [320, 5],
            offset: [0, 0]
          })
            .setLatLng(latLng(collectionEvent.latitude, collectionEvent.longitude))
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .setContent(this.$el as any)
            .openOn(parent.mapObject)
            .on("remove", () => {
              if (mapStore.selectedCollectionEvent === collectionEvent) {
                mapStore.isCollectionEventPopupOpen = false;
                mapStore.selectedCollectionEvent = null;
              }
              this.popup = null;
            });
        } else {
          parent.mapObject.closePopup();
        }
      }
    );
  }

  destroyed() {
    if (this.dispose) this.dispose();
    mapStore.isCollectionEventPopupOpen = false;
    mapStore.selectedCollectionEvent = null;
  }
}
